<template>
  <div>
    <PageMain
      ref="main"
      :tableData="tableData"
      :tablePage="page"
      :loading="loading"
      @reload="reload"
      @check="(e) => $emit('check', e)"
    >
      <PageHeader
        ref="header"
        slot="header"
        @query="getData"
        @reset="resetPage"
        @add="addOptionsVisible = true"
      />
      <pagination
        slot="pager"
        size="mini"
        :layouts="[
          'Total',
          'Sizes',
          'PrevJump',
          'PrevPage',
          'NextPage',
          'NextJump',
          'FullJump',
        ]"
        :current-page="page.curPage"
        :page-size="page.pageSize"
        :page-total="page.pageTotal"
        @change="handlePaginationChange"
      />
    </PageMain>

    <AddOptions :visible.sync="addOptionsVisible" @reload="reload" />
  </div>
</template>

<script>
import PageMain from './main.vue'
import PageHeader from './header.vue'
import AddOptions from '../add-options'
import BaseTable from '@/mixins/base-table'
export default {
  mixins: [BaseTable],
  components: { PageMain, PageHeader, AddOptions },
  data() {
    return { usePage: true, addOptionsVisible: false }
  },
  methods: {
    async getData(form) {
      this.loading = true
      this.$api
        .sampleMetadataOptionsListApi({
          metadataType: 'Content',
          ...form,
          ...this.page,
        })
        .then((res) => {
          this.loading = false
          this.setData(res)
        })
        .catch(() => {
          this.loading = false
        })
    },
  },
}
</script>
